export interface ParentEntity {
    domain?: string | null;
    type: string;
    id: string | number;
}
